import React from 'react';
import { Box, RadioButton, Text } from 'gestalt';

// Converts a FlagOption config object (which groups options according to their "parentOption")
// into a map. Options are keyed uniquely by their value.
export function constructFlagOptionsMap(config) {
  const flagOptionsMap = {};

  for (const parentOption in config) {
    const options = config[parentOption];

    options.forEach((option) => {
      // value should be unique
      const value = option.value;
      if (Object.prototype.hasOwnProperty.call(flagOptionsMap, value)) {
        throw new Error('Duplicate key in FlagOptions config: ' + value);
      }

      flagOptionsMap[value] = option;
      flagOptionsMap[value].parentOption = parentOption;
    });
  }

  return flagOptionsMap;
}

// Helper function to create the label for the flag reason
function createFlagLabel(data, handleSelectReason, selectedReason, idx) {
  const { text, value, category } = data;

  return (
    <label className="flagReasonLabel" htmlFor={value} key={idx}>
      <Box alignItems="center" deprecatedPadding={2} display="flex">
        <RadioButton
          checked={selectedReason === value}
          id={value}
          onChange={(checked) => handleSelectReason(checked, value, category)}
          name="flagReason"
          value={value}
        />
        <Box deprecatedPadding={2}>
          <Text size="sm">{text}</Text>
        </Box>
      </Box>
    </label>
  );
}
/**
 * Utility function used by the Flag* flows to generate content.
 *
 * @param {array} of data objects containing the following:
 *   text - the text to show (wrap input in translation _() )
 *   value - value for the labe land the input (this's the text that gets
 *     sent to the Flag APIs)
 *   isTerminalReason - true if there are no more reasons after this, false otherwise
 *   category - the category associated with the terminal reason.
 *   condition - if a condition is defined and is false, then don't show
 *     the corresponding flagOption
 * @return {array} array of label elements
 */
export function createFlagLabels(arrayOfData, handleSelectReason, selectedReason) {
  return arrayOfData.map((data, idx) => {
    const { condition } = data;

    // if condition is defined and it is falsey, then don't show anything.
    if (typeof condition !== 'undefined' && !condition) {
      return null;
    }

    // if condition is not defined, or it is defined and truthy, then show a flagReason.
    return createFlagLabel(data, handleSelectReason, selectedReason, idx);
  });
}

export default class FlagOptions {
  constructor(config) {
    this.config = config;
    this.configMap = constructFlagOptionsMap(config);
  }

  getFlagOption(value) {
    return this.configMap[value];
  }

  renderFlagLabels(args) {
    const { flagReason, onSelectReason, selectedReason } = args;

    return createFlagLabels(this.config[flagReason], onSelectReason, selectedReason);
  }
}
